module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAA2klEQVQoU6WQMWpCQRRFz1UI2FpYm01EXILLCCncgcFkASmttJGAhJQ2kgVYCEqKlJGQPqQOsdUrb/gfJvC1yZQzc94998n2DngHDlSfS6AvaRHPsv0qqXPiM7bvgB9J4xLYSOqeAW6BXSVgu1aCkpKi7QQAkz8Jtq+AadblSdIoA9pAKzokJdsPwBfwXKT8StpnwAxYBbAFYvo9sJb0YvsipsVSgAHwER1sLwN4jAugmQFDoFcAEXgj6TMBZclCKSWc2dj/gTdJ86oE22GzypWugXD/PqFUBxpHivyB7wPk8l4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon_f2.png
// module id = KcbE
// module chunks = 14 17